// Run-time configuration for the shell. Nothing here is secret: a static bundle is public.

export interface WebConfig {
  /** The Web MMS BFF base URL. Same origin behind Front Door, so a path. */
  apiBaseUrl: string;
  /**
   * How users sign in. `development` uses a development token; `password` is the placeholder email-and-password
   * sign-in for the Development environment until the identity provider (P1); `none` signs nobody in.
   */
  authMethod: 'development' | 'password' | 'none';
  /** A development token from `.env.local`, development server only. */
  developmentToken: string | null;
}

export interface ConfigInput {
  isDevServer: boolean;
  apiBaseUrl?: string;
  authMethod?: string;
  developmentToken?: string;
}

export function readConfig(input: ConfigInput): WebConfig {
  // The identity provider is not chosen (W1). Until it is, only a development server signs anyone in.
  const authMethod =
    input.authMethod === 'password'
      ? 'password'
      : input.authMethod === 'development' || (input.authMethod === undefined && input.isDevServer)
        ? 'development'
        : 'none';
  return {
    apiBaseUrl: input.apiBaseUrl || '/api/web/v1',
    authMethod,
    developmentToken: input.isDevServer ? input.developmentToken || null : null,
  };
}

/**
 * Reads the build's environment. Each value is named on its own, never `import.meta.env` as a whole, so a build
 * inlines only these; the development token sits behind `import.meta.env.DEV`, which a build replaces with false,
 * so it never reaches a bundle.
 */
export function configFromEnvironment(): WebConfig {
  return readConfig({
    isDevServer: import.meta.env.DEV,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
    authMethod: import.meta.env.VITE_AUTH_METHOD,
    developmentToken: import.meta.env.DEV ? import.meta.env.VITE_DEV_TOKEN : undefined,
  });
}
